module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [(_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-mobile-back pp-mobile-back--light",
    on: {
      "click": function($event) {
        return _vm.$root.mobileBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.empty) ? _c('div', {
    staticClass: "pp-header pp-header--simple pp-header--mobile-small"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            Nothing queued\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-header__content"
  }, [_vm._v("\n            Why not try browsing "), _c('router-link', {
    attrs: {
      "to": "/browse/composers"
    }
  }, [_vm._v("popular composers")]), _vm._v("?\n        ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.empty) ? _c('div', {
    staticClass: "pp-header pp-header--simple pp-header--mobile-small"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            Now Playing\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-header__content"
  }, [_vm._v("\n            Tracks in your queue and play history\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.history.length > 0) ? _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n            History\n        ")]), _vm._v(" "), _c('track-list', {
    attrs: {
      "allow-remove": true,
      "reversed": true,
      "items": _vm.history,
      "context-mode": "from-history"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.current.length > 0) ? _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n            Now Playing\n        ")]), _vm._v(" "), _c('track-list', {
    attrs: {
      "allow-remove": true,
      "items": _vm.current
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.queue.length > 0) ? _c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n            Up Next\n        ")]), _vm._v(" "), _c('track-list', {
    attrs: {
      "allow-remove": true,
      "items": _vm.queue,
      "context-mode": "from-queue"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09c2bc73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Queue.vue
// module id = 116
// module chunks = 0 1